export default __webpack_public_path__ + "static/Ogg-BoldItalic-8c59e938db40b96c5ec44a1ce0410c5b.ttf";